// Fallbacks used when the meter lookup doesn't say otherwise.
export const MIN_AMOUNT = 1000; // hard floor for a purchase (₦)
export const DEFAULT_CHARGES = 200; // transfer charge (₦), used until the API supplies one
